import { render, staticRenderFns } from "./AOIInfo.vue?vue&type=template&id=00c06198&scoped=true&"
import script from "./AOIInfo.vue?vue&type=script&lang=js&"
export * from "./AOIInfo.vue?vue&type=script&lang=js&"
import style0 from "./AOIInfo.vue?vue&type=style&index=0&id=00c06198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c06198",
  null
  
)

export default component.exports